import React, { memo, useCallback, useMemo, useRef } from 'react';
import ReactSlider from 'react-slider';
import { Tooltip } from '@yme/atoms/tooltip';
import { buildKey } from '@yme/utils/common';
import { ThumbStyled, TrackStyled } from './styled';
export const Slider = memo(({ min, max, low, high, dataTestId, isRightToLeft, onChange, }) => {
    const containerRef = useRef(null);
    const handleChange = useCallback(([_low, _high]) => {
        onChange({
            low: _low,
            high: _high,
        });
    }, [onChange]);
    const value = useMemo(() => [low, high], [high, low]);
    const renderThumb = useCallback((props, { index, valueNow }) => {
        const containerLeft = containerRef.current
            ? containerRef.current.getBoundingClientRect().left
            : 0;
        const containerRight = containerRef.current
            ? containerRef.current.getBoundingClientRect().right
            : 0;
        const thumbLeft = parseInt(props.style?.left, 10);
        const thumbRight = parseInt(props.style?.right, 10);
        return (React.createElement(Tooltip, { key: buildKey('tooltip', index), title: String(valueNow), outerDynamicLeftCoord: isRightToLeft ? containerRight - thumbRight : containerLeft + thumbLeft },
            React.createElement(ThumbStyled, { ...props })));
    }, [isRightToLeft]);
    const renderTrack = useCallback((props, { index }) => (React.createElement(TrackStyled, { ...props, index: index })), []);
    return (React.createElement("div", { ref: containerRef, "data-testid": dataTestId },
        React.createElement(ReactSlider, { min: min, max: max, invert: isRightToLeft, value: value, minDistance: 1, renderThumb: renderThumb, renderTrack: renderTrack, onChange: handleChange })));
});
Slider.displayName = 'Slider';
